<template>
	<b-container fluid>
		<b-row v-if="status === 'FAILED'">
			<b-col>
				<b-alert :show="status === 'FAILED'" variant="danger">{{message}}</b-alert>
			</b-col>
		</b-row>
		<b-row v-if="status !== 'RUNNING'" class="p-0 m-0">
			<b-col class="p-0">
				<b-alert :show="status === 'SUCCESS' && message !== null" dismissible variant="warning">{{message}}</b-alert>
			</b-col>
			<b-col class="d-flex flex-row justify-content-end p-0">
				<span class="pl-2 bd-highlight">
					<b-button variant="outline-primary" @click="saveDialog.visible=true" v-b-tooltip.hover title="Save Query"><icon name="save"></icon></b-button>
				</span>
				<span class="pl-2 bd-highlight">
					<b-form-select id="per-page-select" v-model="rowsPerPage">
						<b-form-select-option :value="10">10</b-form-select-option>
						<b-form-select-option :value="20">20</b-form-select-option>
						<b-form-select-option :value="50">50</b-form-select-option>
						<b-form-select-option :value="100">100</b-form-select-option>
					</b-form-select>
				</span>
				<span class="pl-2 bd-highlight">
					<b-pagination variant="outline-secondary" v-model="pageNo" :total-rows="totalRows" :per-page="rowsPerPage"/>
				</span>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-skeleton-wrapper :loading="status === 'RUNNING'">
					<template #loading>
						<b-skeleton-table animation="throb" :rows="5" :columns="4" :table-props="{ hover: true, bordered: true, striped: true }"></b-skeleton-table>
					</template>
					<b-table v-if="status ==='SUCCESS'" head-variant="light" no-border-collapse bordered striped hover small sticky-header :items="table" :fields="fields" :current-page="pageNo" :per-page="rowsPerPage"/>
				</b-skeleton-wrapper>
			</b-col>
		</b-row>
		<div>
			<b-modal :id="'save-dialog-' + query.id" centered title="Save Query" v-model="saveDialog.visible">
				<b-row>
					<b-col>
						<b-form-group id="name-id" label="Name:" label-for="name" description="Name the query">
							<b-form-input id="name" type="text" v-model="saveDialog.name" autofocus required placeholder="Query Name"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group id="description-id" label="Description:" label-for="description" description="Describe the query">
							<b-form-textarea id="description" type="text" v-model="saveDialog.description" placeholder="Query Description" rows="5"></b-form-textarea>
						</b-form-group>
					</b-col>
				</b-row>
				<template #modal-footer>
					<div class="w-100">
						<p class="float-left"></p>
						<b-button-group class="float-right">
							<b-button variant="primary" @click="saveQuery()">Save</b-button>
							<b-button variant="outline-secondary" @click="saveDialog.visible=false">Cancel</b-button>
						</b-button-group>
					</div>
				</template>
			</b-modal>
		</div>
	</b-container>
</template>

<script>
import {HTTP} from '../services/HttpService'
export default {
  name: 'query',
  props: {
    query: Object
  },
  data () {
    return {
      status: 'RUNNING',
      fields: [],
      table: [],
      pageNo: 1,
      totalRows: 0,
      rowsPerPage: 20,
      message: null,
      saveDialog: {
        visible: false,
        name: '',
        description: ''
      }
    }
  },
  mounted: function () {
  },
  methods: {
    executeQuery () {
      console.log('Executing Query for TAB: ' + this.query.id)
      this.query.status = 'Running'
      const formData = new FormData()
      formData.append('query', this.query.sql)
      HTTP.post('api/query/execute', formData)
        .then(response => {
          console.log('Processing response')
          var result = response.data
          this.status = result.status
          this.message = result.error
          if (result.status === 'FAILED') {
            this.query.status = 'Done'
            this.error = result.error
            console.log('Status=' + this.status)
            console.log('Error=' + this.error)
            this.$emit('onComplete', this.query.id)
            return
          }
          var table = []
          for (var row of result.data) {
            var tableRow = {}
            for (var cell in row) {
              var key = result.columns[cell].name
              var value = row[cell]
              tableRow[key] = value
            }
            // console.log(tableRow)
            table.push(tableRow)
          }
          console.log('Setting table data')
          var fields = []
          for (var column of result.columns) {
            let tdClass = 'text-nowrap'
            switch (column.dataTypeText) {
              case 'INTEGER':
              case 'BIGINT':
              case 'DOUBLE':
              case 'FLOAT':
              case 'DECIMAL':
                tdClass += ' text-right'
                break
              case 'TIMESTAMP':
              case 'DATE':
                tdClass += ' text-center'
                break
            }
            var field = {
              key: column.name,
              label: column.name,
              headerTitle: column.name,
              sortable: true,
              thClass: 'text-center',
              tdClass: tdClass
            }
            fields.push(field)
          }
          this.fields = fields
          this.totalRows = table.length
          this.table = table
          this.query.status = 'Done'
          console.log('Done')
          this.$emit('onComplete', this.query.id)
        })
    },
    saveQuery () {
      const formData = new FormData()
      formData.append('name', this.saveDialog.name)
      formData.append('description', this.saveDialog.description)
      formData.append('sql', this.query.sql)
      HTTP.post('api/queries', formData)
        .then(response => {
          this.saveDialog.visible = false
          this.name = ''
          this.description = ''
        })
    }
  },
  created () {
    this.executeQuery()
  }
}
</script>

<style>
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
}
</style>



// WEBPACK FOOTER //
// Query.vue?248becc4